import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { formatEuro } from '../lib/calcoli'

export default function DettaglioPratica() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [pratica, setPratica] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => { fetch() }, [id])

  async function fetch() {
    setLoading(true)
    // Join con profiles per esporre il dealer che ha inviato la pratica (utile soprattutto per admin)
    const { data } = await supabase
      .from('pratiche')
      .select('*, dealer:profiles!pratiche_dealer_id_fkey(id, nome, cognome, email, ruolo)')
      .eq('id', id).single()
    setPratica(data)
    setLoading(false)
  }

  async function elimina() {
    if (!window.confirm('Eliminare questa pratica? I dati saranno cancellati definitivamente.')) return
    await supabase.from('pratiche').delete().eq('id', id)
    navigate('/pratiche')
  }

  if (loading) return <div className="loading">Caricamento...</div>
  if (!pratica) return <div className="alert alert-error">Pratica non trovata</div>

  const dc = pratica.dati_comuni || {}
  const prev = pratica.preventivi || {}
  const isAutocarri = pratica.tipo_operazione === 'autocarri_intermediari'

  return (
    <div>
      <div className="page-header flex-between">
        <div>
          <h1>Pratica {pratica.numero_pratica}</h1>
          <p>{pratica.cliente_cognome} {pratica.cliente_nome} · creata il {new Date(pratica.created_at).toLocaleString('it-IT')}</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-danger" onClick={elimina}>Elimina</button>
          <button className="btn" onClick={() => navigate('/pratiche')}>← Torna</button>
        </div>
      </div>

      {pratica.dealer && (
        <div className="card" style={{ marginBottom: '1rem' }}>
          <h2 className="card-title">Compilata da</h2>
          <div className="stat-grid">
            <div className="stat-card">
              <div className="sl">Nome</div>
              <div className="sv">{`${pratica.dealer.cognome || ''} ${pratica.dealer.nome || ''}`.trim() || '—'}</div>
            </div>
            <div className="stat-card">
              <div className="sl">Email</div>
              <div className="sv" style={{ fontSize: 14 }}>{pratica.dealer.email}</div>
            </div>
            <div className="stat-card">
              <div className="sl">Ruolo</div>
              <div className="sv" style={{ textTransform: 'capitalize' }}>{pratica.dealer.ruolo}</div>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <h2 className="card-title">Dati pratica</h2>
        <div className="stat-grid">
          <div className="stat-card"><div className="sl">Provincia</div><div className="sv">{dc.provincia || '—'}</div></div>
          <div className="stat-card"><div className="sl">Valore auto</div><div className="sv">{formatEuro(parseFloat(dc.valore_auto))}</div></div>
          <div className="stat-card"><div className="sl">Durata</div><div className="sv">{dc.durata_mesi} mesi</div></div>
          <div className="stat-card"><div className="sl">Causale</div><div className="sv">{dc.causale ? dc.causale.charAt(0).toUpperCase() + dc.causale.slice(1) : (dc.stato_veicolo || '—')}</div></div>
          <div className="stat-card">
            <div className="sl">Satellitare</div>
            <div className="sv">
              {dc.satellitare ? 'Sì' : 'No'}
              {dc.satellitare && (dc.sat_marca || dc.sat_seriale) && (
                <div className="text-small text-muted" style={{ marginTop: 4 }}>
                  {dc.sat_marca && <>Marca: <strong>{dc.sat_marca}</strong></>}
                  {dc.sat_marca && dc.sat_seriale && ' · '}
                  {dc.sat_seriale && <>Seriale: <strong>{dc.sat_seriale}</strong></>}
                </div>
              )}
              {!dc.satellitare && dc.acquista_lojack && (
                <div className="text-small text-muted" style={{ marginTop: 4 }}>
                  Acquista satellitare: <strong>{dc.mesi_lojack || dc.durata_mesi || 12} mesi</strong>
                </div>
              )}
            </div>
          </div>
          <div className="stat-card"><div className="sl">Pacchetto</div><div className="sv">{dc.pacchetto}</div></div>
          <div className="stat-card"><div className="sl">Colore auto</div><div className="sv">{dc.colore_auto || '—'}</div></div>
          <div className="stat-card"><div className="sl">Chilometri</div><div className="sv">{dc.km != null ? `${dc.km} km` : '—'}</div></div>
        </div>
      </div>

      {(dc.email_contraente || dc.cellulare_contraente) && (
        <div className="card mt-2">
          <h2 className="card-title">Contatti contraente</h2>
          <div className="stat-grid">
            <div className="stat-card"><div className="sl">Email</div><div className="sv" style={{ fontSize: 14 }}>{dc.email_contraente || '—'}</div></div>
            <div className="stat-card"><div className="sl">Cellulare</div><div className="sv" style={{ fontSize: 14 }}>{dc.cellulare_contraente || '—'}</div></div>
          </div>
        </div>
      )}

      {dc.consenso_privacy && (
        <div className="card mt-2" style={{ background: '#f0f9f4', borderColor: '#16a34a' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 22 }}>🔒</span>
            <div>
              <strong>Consenso privacy registrato</strong>
              <div className="text-small text-muted">
                Confermato dal dealer il <strong>{dc.consenso_privacy_at ? new Date(dc.consenso_privacy_at).toLocaleString('it-IT') : '—'}</strong>
                {dc.consenso_privacy_version && <> (versione informativa {dc.consenso_privacy_version})</>}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="card mt-2">
        <h2 className="card-title">Compagnie comparate</h2>
        <div className="comp-grid">
          {pratica.compagnie_selezionate.map(codice => {
            const r = prev[codice]
            return (
              <div key={codice} className={`comp-card ${pratica.scelta_compagnia === codice ? 'selected' : ''}`}>
                <div className="comp-name">{codice}</div>
                {r?.ok ? (
                  <>
                    <div className="comp-total">{formatEuro(r.totale)}</div>
                    <div className="comp-month">{formatEuro(r.premio_mensile)}/mese</div>
                  </>
                ) : (
                  <div className="comp-tag">⚠ {(r?.errors || []).join(', ')}</div>
                )}
              </div>
            )
          })}
        </div>
      </div>

      {pratica.totale_finale && (
        <div className="total-box purple mt-3">
          <div className="tl">Totale pratica scelto</div>
          <div className="tv">{formatEuro(pratica.totale_finale)}</div>
        </div>
      )}

      <div className="info-box amber mt-2">
        Per concludere e inviare la pratica, riapri il wizard dalla lista pratiche.
        Gli allegati documentali devono essere ricaricati nello step "Documenti" prima dell'invio
        (non vengono salvati nel database per motivi di privacy).
      </div>
    </div>
  )
}
